import Icon from 'components/Icon'
import { ToastType } from 'components/Toast/types'

export type ToastStyleProps = {
  [k in ToastType]: {
    icon: JSX.Element
    style: string
  }
}

export const ToastStyleProps: ToastStyleProps = {
  success: {
    icon: <Icon name="success" color="element-inverse" />,
    style: 'success',
  },
  alert: {
    icon: <Icon name="error" color="element-inverse" />,
    style: 'alert',
  },
}
